var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "snack-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eazle---App-views",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-products",
    transform: "translate(-48, -763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-5",
    transform: "translate(24, 739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "snack-icon",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chips",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)",
    fill: "#00414B"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.8668, 2.3333)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.227044775,0.365546667 C0.416991442,0.134133333 0.700631442,0 1,0 L21.2666848,0 C21.5660181,0 21.8497514,0.134133333 22.0396181,0.365546667 C22.2296181,0.596946667 22.3058848,0.901293333 22.2474848,1.19492 L21.4493514,5.21108 C21.4728181,5.31748 21.5033514,5.46034667 21.5386848,5.6376 C21.6206848,6.04965333 21.7289514,6.64788 21.8366848,7.40586667 C22.0521514,8.92122667 22.2666982,11.0788 22.2666982,13.6666667 C22.2666982,16.2545333 22.0521514,18.4121333 21.8366848,19.9274667 C21.7289514,20.6854667 21.6206848,21.2837333 21.5386848,21.6957333 C21.5033514,21.8729333 21.4728181,22.0158667 21.4493514,22.1222667 L22.2474848,26.1384 C22.3058848,26.432 22.2296181,26.7364 22.0396181,26.9677333 C21.8497514,27.1992 21.5660181,27.3333333 21.2666848,27.3333333 L1,27.3333333 C0.700631442,27.3333333 0.416991442,27.1992 0.227044775,26.9677333 C0.0371114418,26.7364 -0.0391685582,26.432 0.0191914418,26.1384 L0.817351442,22.1222667 C0.793804775,22.0158667 0.763324775,21.8729333 0.728018109,21.6957333 C0.645951442,21.2837333 0.537764775,20.6854667 0.429964775,19.9274667 C0.214471442,18.4121333 0,16.2545333 0,13.6666667 C0,11.0788 0.214471442,8.92122667 0.429964775,7.40586667 C0.537764775,6.64788 0.645951442,6.04965333 0.728018109,5.6376 C0.763324775,5.46034667 0.793804775,5.31748 0.817351442,5.21108 L0.0191914418,1.19492 C-0.0391685582,0.901293333 0.0371114418,0.596946667 0.227044775,0.365546667 Z M2.66083144,4.22666667 L19.6058848,4.22666667 L20.0484181,2 L2.21829811,2 L2.66083144,4.22666667 Z M2.65085811,6.22666667 C2.58105811,6.59318667 2.49568478,7.08524 2.41004478,7.68746667 C2.20555144,9.12544 2.00000478,11.1878667 2.00000478,13.6666667 C2.00000478,16.1454667 2.20555144,18.2078667 2.41004478,19.6458667 C2.49568478,20.2481333 2.58105811,20.7401333 2.65085811,21.1066667 L19.6158848,21.1066667 C19.6856181,20.7401333 19.7709514,20.2481333 19.8566848,19.6458667 C20.0610848,18.2078667 20.2666848,16.1454667 20.2666848,13.6666667 C20.2666848,11.1878667 20.0610848,9.12544 19.8566848,7.68746667 C19.7709514,7.08524 19.6856181,6.59318667 19.6158848,6.22666667 L2.65085811,6.22666667 Z M19.6058848,23.1066667 L2.66083144,23.1066667 L2.21829811,25.3333333 L20.0484181,25.3333333 L19.6058848,23.1066667 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6061514,9.14465333 C16.9529514,9.06628 17.3150848,9.17786667 17.5577514,9.43773333 C17.8074848,9.70530667 18.0105514,9.99692 18.1853514,10.2990133 L18.1870848,10.30192 C18.6292181,11.0716 18.8933514,11.9756 18.8933514,12.9333333 C18.8933514,15.8456 16.5389514,18.2 13.6266848,18.2 C12.7254848,18.2 11.8777514,17.9724 11.1362848,17.5746667 C10.3917514,17.9752 9.54468478,18.2 8.64001811,18.2 C5.72768478,18.2 3.37329811,15.8456 3.37329811,12.9333333 C3.37329811,11.9756 3.63740478,11.0716 4.07952478,10.30192 L4.08913811,10.2855467 C4.23069811,10.0496267 4.37279144,9.84458667 4.52733811,9.64366667 C4.76041811,9.34066667 5.14584478,9.19705333 5.52036478,9.27366667 C7.21377811,9.62004 8.97335144,9.80004 10.7733514,9.80004 C12.7761514,9.80004 14.7289514,9.56896 16.6061514,9.14465333 Z M9.41548478,16.1090667 L5.73301811,11.4473333 C5.50464478,11.896 5.37329811,12.4041333 5.37329811,12.9333333 C5.37329811,14.7410667 6.83225811,16.2 8.64001811,16.2 C8.90855144,16.2 9.16775144,16.1686667 9.41548478,16.1090667 Z M8.48868478,11.7092 L11.0498848,14.9516 C11.6573514,15.7125333 12.5882848,16.2 13.6266848,16.2 C15.4342848,16.2 16.8933514,14.7410667 16.8933514,12.9333333 C16.8933514,12.3450667 16.7310848,11.7829333 16.4536181,11.2994667 C16.4401514,11.2762667 16.4266848,11.2534667 16.4132181,11.2313333 C14.5920181,11.6004 12.7053514,11.8 10.7733514,11.8 C10.0049514,11.8 9.24281811,11.7694667 8.48868478,11.7092 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackIcon);
export default __webpack_public_path__ + "static/media/snack-icon.d48328362eb0578c2c1aafddf19781fa.svg";
export { ForwardRef as ReactComponent };